/**
 * A top-level menu item that has a list under it is the name of that list, not
 * somewhere to go. On the bar it opens the list; in the drawer, where the list
 * is already open, it is inert.
 *
 * The href is taken off rather than the click merely swallowed, so a
 * middle-click or a copied link cannot reach the page either — and the role and
 * tabindex put back what dropping the href would otherwise cost a keyboard or a
 * screen reader.
 */
(function () {
  function asHeading(link, onActivate) {
    if (link.dataset.esHeading) return;
    link.dataset.esHeading = '1';
    link.removeAttribute('href');
    link.setAttribute('role', onActivate ? 'button' : 'heading');

    if (!onActivate) {
      link.setAttribute('aria-level', '3');
      return;
    }

    link.setAttribute('tabindex', '0');
    link.addEventListener('click', function (event) {
      event.preventDefault();
      onActivate();
    });
    link.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onActivate();
      }
    });
  }

  function mirror(link, toggle) {
    var open = toggle.getAttribute('aria-expanded') || 'false';
    // Only written when it actually differs: this runs on every pass, and a
    // needless attribute write on a watched subtree is a pass that schedules
    // the next one.
    if (link.getAttribute('aria-expanded') !== open) {
      link.setAttribute('aria-expanded', open);
    }
  }

  function bind() {
    document.querySelectorAll('header-component.header .menu-list__trigger > a.menu-list__link').forEach(function (link) {
      var toggle = link.parentElement.querySelector('.menu-list__disclosure');
      if (!toggle) return;
      asHeading(link, function () {
        toggle.click();
        mirror(link, toggle);
      });
      mirror(link, toggle);
    });

    document.querySelectorAll('header-component.header .menu-drawer__menu-item--mainlist').forEach(function (link) {
      var item = link.closest('li');
      if (!item || !item.querySelector('ul')) return;
      asHeading(link, null);
    });
  }

  /**
   * The header hydrates after first paint and swaps its own markup — the drawer
   * in particular — so a single pass at parse time catches the bar but misses
   * the drawer.
   *
   * What is watched is the header's own section wrapper, not the document. The
   * wrapper is what Shopify's section rendering replaces the header inside, so
   * it survives the header element itself being swapped, which was the reason
   * the document was being watched — but a product page mutates its body many
   * hundreds of times while the recommendations, the pixels and the review
   * widget arrive, and every one of those was waking this file to run two
   * document-wide querySelectorAll passes. It measured 294ms of script time and
   * two long tasks over 100ms on the product page.
   *
   * The batching is a timeout and deliberately not a rAF: rAF callbacks are
   * suspended while the tab is in the background, so a drawer that hydrated on
   * a background tab would stay a live link until the tab was looked at.
   */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      bind();
    }, 150);
  }

  function headerScope() {
    var host = document.querySelector('header-component.header');
    if (!host) return null;
    return host.closest('[id^="shopify-section"]') || host.parentElement || host;
  }

  function start() {
    bind();
    var scope = window.MutationObserver ? headerScope() : null;
    if (scope) {
      new MutationObserver(schedule).observe(scope, { childList: true, subtree: true });
    }
    // A couple of late sweeps in case a script replaces part of the header
    // without the observer being in place yet.
    setTimeout(bind, 400);
    window.addEventListener('load', bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();